import styled, {keyframes} from "styled-components";

const chestScaleAnimation = keyframes`
            0% {                
                transform: scale(1);
            }
             40%, 50% {                
                transform: scale(1.2);
            }
             100% {                
                transform: scale(1);
            }
            `;


export const DailyDealChestBox = styled.img` 
        
        grid-column: 1;
        grid-row: 1;
    
        position: relative;
        height: 50px;
        
        animation: ${chestScaleAnimation} 2s infinite;
`;
